import { createSelector } from 'reselect';
import get from 'lodash/get';
import { makeSelectorFactory } from '../../../utils/redux/selectAdapter';

export const selectRootState = state => get(state, 'board');
const getSelectors = makeSelectorFactory(selectRootState);

export const relatedUsersSelector = state => state.board.reqRelatedUsers;

export const membersSelector = createSelector(
  relatedUsersSelector,
  members => get(members, 'list', []),
);

export const sendingSelector = createSelector(
  relatedUsersSelector,
  request => get(request, 'sending') || false,
);

export const selectSucceedRelatedUsers = createSelector(
  relatedUsersSelector,
  request => get(request, 'succeed') || false,
);

export const {
  selectStatePending: selectReqInvitePatientPending,
  selectStateError: selectReqInvitePatientError,
  selectStateSucceed: selectReqInvitePatientSucceed,
} = getSelectors('reqInvitePatient');

export const {
  selectStatePending: selectReqAssignPatientPending,
  selectStateSucceed: selectReqAssignPatientSucceed,
} = getSelectors('reqAssignPatient');



// WEBPACK FOOTER //
// ./src/redux/board/selectors/relatedUsers.js